export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Po potvrzení externího převodu bude automaticky proveden interní převod z vašeho účtu na účet obchodníka a obchod bude dokončen."])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Potvrdit přijetí převodu a dokončit obchod?"])},
  "3": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ano, potvrdit"])},
  "4": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ne, ponechat aktivní"])}
}